export const REVIEWS = [
  {
    id: 1,
    name: "Ankush",
    role: "CTO",
    avatar:
      "https://images.pexels.com/photos/17653924/pexels-photo-17653924/free-photo-of-man-in-black-shirt-driving-green-jeep.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    review:
      "We got cost reduction in whole IT hardwares, and we are able to reduce 15%-23% of IT cost with Vipendra.I think its a good business with Quantarock.",
  },
  {
    id: 2,
    name: "Wasim",
    role: "Founder and CEO",
    avatar:
      "https://images.pexels.com/photos/7580922/pexels-photo-7580922.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    review:
      "Tech support and consultation is a huge issue with us because we are a startup, Quantarock give free support and consultation.",
  },
  {
    id: 3,
    name: "Michael",
    role: "Crypto Mining farm",
    avatar:
      "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    review:
      "Results speak louder than words. I've never seen progress like this. The workflows are challenging but oh-so-rewarding. Kudos!",
  },
];

export const ALL_DETAIL_ROUTES_INFO = [...REVIEWS];
